import { type NavigateOptions, useLocation, useNavigate, useParams } from 'react-router-dom';
import { parseOperatorId, withCellPrefix, withoutCellPrefix } from './market-routing';

export function useHubPathname(): string {
  const { pathname } = useLocation();
  return withoutCellPrefix(pathname);
}

export function useHubHref(): (path: string) => string {
  const { operatorId } = useParams<{ operatorId?: string }>();
  const { pathname } = useLocation();
  const cellId = operatorId ?? parseOperatorId(pathname);
  return (path: string) => withCellPrefix(path, cellId);
}

export function useHubNavigate() {
  const navigate = useNavigate();
  const href = useHubHref();
  return (to: string, opts?: NavigateOptions) => navigate(href(to), opts);
}
